module.exports = __webpack_public_path__ + "static/img/medical_bg.476a4f6e.png";